import React from 'react';
import SiriusTable from '@lingxi-common-component/sirius-ui/Table';
import IconSuccess from '@/components/UI/Icons/svgs/Success';
import styles from './OpenRecords.module.scss';
import { getIn18Text } from 'api';
export const isThirdSendFn = (content) => {
    var _a, _b, _c;
    if (!((_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.mTrack)) {
        if (((_b = content === null || content === void 0 ? void 0 : content.entry) === null || _b === void 0 ? void 0 : _b.sendTime) && new Date((_c = content === null || content === void 0 ? void 0 : content.entry) === null || _c === void 0 ? void 0 : _c.sendTime).getTime() > new Date('2024-09-01').getTime()) {
            return true;
        }
        else {
            return false;
        }
    }
    return false;
};
const columnsWaimao = [
    {
        title: getIn18Text('DANGDISHIJIAN'),
        dataIndex: 'remoteLocalTime',
        key: 'remoteLocalTime',
        render: (text) => text || '--',
    },
    {
        title: getIn18Text('DAKAIDIDIAN'),
        dataIndex: 'location',
        key: 'location',
        render: (text) => text || '--',
    },
    {
        title: getIn18Text('BENDISHIJIAN'),
        dataIndex: 'settingTime',
        key: 'settingTime',
        render: (text) => text || '--',
    },
    {
        title: getIn18Text('IPDIZHI'),
        dataIndex: 'ip',
        key: 'ip',
        render: (text) => text || '--',
    },
];
const columnsLx = [
    {
        title: getIn18Text('DANGDISHIJIAN'),
        dataIndex: 'remoteLocalTime',
        key: 'remoteLocalTime',
        render: (text) => text || '--',
    },
    {
        title: getIn18Text('BENDISHIJIAN'),
        dataIndex: 'settingTime',
        key: 'settingTime',
        render: (text) => text || '--',
    },
];
const OpenRecords = ({ openRecordData, forbid = false }) => {
    var _a;
    return (React.createElement(React.Fragment, null, React.createElement(React.Fragment, null, React.createElement("div", { className: styles.multiRecords },
        React.createElement("div", { className: styles.openRecordTitle },
            React.createElement(IconSuccess, { transform: "scale(0.8)" }),
            React.createElement("span", { className: styles.openText }, getIn18Text('YOUJIANYIBEIDAKC', { openRecordData: (openRecordData === null || openRecordData === void 0 ? void 0 : openRecordData.count) || 0 }))),
        React.createElement("div", { className: styles.openRecordTable },
            React.createElement(SiriusTable, { pagination: false, columns: process.env.BUILD_ISEDM ? columnsWaimao : columnsLx, dataSource: openRecordData.records, loading: false, bordered: true, scroll: {
                    y: (openRecordData === null || openRecordData === void 0 ? void 0 : openRecordData.records) && ((_a = openRecordData === null || openRecordData === void 0 ? void 0 : openRecordData.records) === null || _a === void 0 ? void 0 : _a.length) > 6 ? 300 : undefined,
                } }))))));
};
export default OpenRecords;
